import React, { FC } from 'react';
import useTranslation from '../../hooks/useTranslation';
import { Box } from '@mui/material';
import { getFyNumber, updateFy } from '../../utils/calculation';
import { MultiSelectField } from '@ingka-group-digital/expansion-multiselect';
import { ApprovedCrpComboBoxProps } from './ApprovedCrpComboBoxProps';
import { PartOfCrp } from '../../models/project';
import CompactPillOverlay from '../CompactPillOverlay';

const noop = () => undefined;

const ApprovedCrpComboBox: FC<ApprovedCrpComboBoxProps> = ({
  partOfCrp,
  handleUpdate,
  disabled,
  label,
  id,
  maxDisplayItems,
}) => {
  const t = useTranslation();
  const selectedValuesIds = (partOfCrp || [])
    .filter((e) => e.approved)
    .map((e) => e.fiscalYear)
    .sort((a, b) => getFyNumber(a) - getFyNumber(b));

  const dropDownValues = () =>
    (partOfCrp || [])
      .map((e) => ({
        value: e.fiscalYear,
        label: `${e.fiscalYear}-${updateFy(e.fiscalYear, +2)}`,
      }))
      .sort((a, b) => getFyNumber(a.value) - getFyNumber(b.value));

  const updateSelectedValues = (newSelections: string[]) => {
    const updated: PartOfCrp[] = (partOfCrp || []).map((e) => ({
      ...e,
      approved: newSelections.includes(e.fiscalYear),
    }));
    handleUpdate(updated);
  };

  const useCompact = maxDisplayItems !== undefined;
  const selectId = id || 'approved_crp_select';

  return (
    <Box
      sx={{
        '& .approved_crp_select__value-container > div': {
          display: 'flex',
          'flex-wrap': 'wrap',
        },
        ...(useCompact && {
          position: 'relative',
          [`& #${selectId}-wrapper .${selectId}__multi-value`]: {
            display: 'none',
          },
        }),
      }}
    >
      {useCompact && (
        <CompactPillOverlay
          selectedValues={selectedValuesIds}
          maxDisplayItems={maxDisplayItems}
        />
      )}
      <MultiSelectField
        id={selectId}
        options={dropDownValues()}
        selectedValues={selectedValuesIds}
        setSelectedValues={disabled ? noop : updateSelectedValues}
        getOptionIsDisabled={disabled ? () => true : undefined}
        label={label !== undefined ? label : t('common.partOfApprovedCRP')}
        displayCountOnly={useCompact}
      />
    </Box>
  );
};

export default ApprovedCrpComboBox;
